import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, Button, Box } from "@mui/material";
import appImage from "../assets/popup.png";

const Popup = () => {
  const [open, setOpen] = useState(false);

  // 🔥 Show popup initially after 5 seconds if not downloaded
  useEffect(() => {
    const downloaded = localStorage.getItem("getmyrank_downloaded");

    if (!downloaded) {
      const timer = setTimeout(() => {
        setOpen(true);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleDownload = () => {
    // Open Play Store link
    window.open(
      "https://play.google.com/store/apps/details?id=com.getmyrank&hl=en",
      "_blank"
    );

    // Optionally mark as downloaded
    // localStorage.setItem("getmyrank_downloaded", "true");

    // Close popup immediately
    setOpen(false);

    // Reopen after 5 seconds
    setTimeout(() => {
      setOpen(true);
    }, 5000);
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 5,
          overflow: "hidden",
        },
      }}
    >
      <DialogContent sx={{ textAlign: "center", p: 0 }}>
        {/* IMAGE */}
        <Box
          component="img"
          src={appImage}
          alt="Download App"
          sx={{ width: "100%" }}
        />

        {/* DOWNLOAD BUTTON */}
        <Button
          fullWidth
          onClick={handleDownload}
          sx={{
            py: 1.8,
            bgcolor: "#fff",
            color: "#163a63",
            fontSize: 17,
            fontWeight: 900,
            borderRadius: 0,
            "&:hover": {
              bgcolor: "#163a63",
              color: "#fff",
            },
          }}
        >
          📲 Download App
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default Popup;
